import React from "react";
import { useLocation } from "react-router-dom";

import TargetDetail from "./TargetDetail";
import TargetBuilderRoute from "./TargetBuilderRoute";

/**
 * Decides whether to render the read-only target detail view or the target
 * builder in edit mode, based on the `?mode=edit` query param.
 *
 * Mounted by `ClientDetailsRouter` when the URL is
 * `/clients/:id/goals-targets/:slug/target/:subSlug` and `subSlug !== "new"`.
 */
const TargetRouteSwitch: React.FC = () => {
  const { search } = useLocation();
  const mode = new URLSearchParams(search).get("mode");
  return mode === "edit" ? <TargetBuilderRoute /> : <TargetDetail />;
};

export default TargetRouteSwitch;
